import { Link } from "react-router-dom";
import { Icon } from "../components/ui/Icon";

/** 401 — the canvas's "Sign-in required" state. */
export function UnauthorizedPage(): JSX.Element {
  return (
    <div className="state-screen" data-testid="unauthorized-page">
      <div className="state-mark">
        <Icon name="lockLarge" size={18} />
      </div>
      <h2>Sign-in required</h2>
      <p>Your session is no longer valid. Sign in again to continue.</p>
      <Link className="btn btn-primary state-actions" to="/login">
        Sign in
      </Link>
    </div>
  );
}
